import React from 'react';
import HeaderTwo from './HeaderTwo';
import HeroSectionTwo from './HeroSectionTwo';
import AboutUsTwo from './AboutUsTwo';
import FeaturesAndBenifit from './FeaturesAndBenifit';
import HowItWorkPage from './HowItWorkPage';
import FaqTwo from './FaqTwo';
import ContactAndSupport from './ContactAndSupport';
import FooterTwo from './FooterTwo';
import FeaturesRockpay from './FeaturesRockpay';

const LandingPage = () => {
    return(
        <>
        <HeaderTwo/>
        <HeroSectionTwo/>
        <AboutUsTwo/>
        <FeaturesAndBenifit/>
        {/* <HowItWorkPage/> */}
        <FeaturesRockpay/>
        <FaqTwo/>
        <ContactAndSupport/>
        <FooterTwo/>
        </>
    );
};

export default LandingPage;